import { useState } from "react";
import { useNavigate } from "react-router-dom";
import Alert from "./Alert";
import { apiURL } from "../api";

export default function CreateNewTask() {
  const [section, setSection] = useState("Functions");
  const [title, setTitle] = useState("");
  const [orderNumber, setOrderNumber] = useState(0);
  const [complexity, setComplexity] = useState(0);
  const [text, setText] = useState("");
  const [code, setCode] = useState("");
  const [codeLanguage, setCodeLanguage] = useState("javascript");
  const [optionalText, setOptionalText] = useState("");
  const navigate = useNavigate();

  const [alertMessage, setAlertMessage] = useState("");
  const [alertClass, setAlertClass] = useState("d-none");

  const handleCreateTask = (event) => {
    event.preventDefault();
    const requestOptions = {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      credentials: "include",
      body: JSON.stringify({
        method: "task.create",
        params: {
          section: section,
          title: title,
          orderNumber: orderNumber,
          complexity: complexity,
          text: text,
          code: code,
          codeLanguage: codeLanguage,
          optionalText: optionalText,
        },
      }),
    };

    fetch(apiURL + "/admin", requestOptions)
      .then((response) => response.json())
      .then((response) => {
        if (response.error) {
          throw new Error(response.error.message);
        }
        const routePath = `/tasks/${section.toLowerCase()}`;
        navigate(routePath);
      })
      .catch((error) => {
        console.error("Failed to create new task:", error);
        setAlertMessage(error.message);
        setAlertClass("alert-danger");
      })
      .finally(() => {});
  };

  return (
    <form className="mx-5" onSubmit={handleCreateTask}>
      <h3 className="my-3">Create New Task</h3>
      <div className="mb-3">
        <label htmlFor="newTaskCreateSection" className="col-form-label">
          Section:
        </label>
        <select
          className="form-select"
          aria-label="Section"
          onChange={(event) => setSection(event.target.value)}
          defaultValue="Functions"
        >
          <option value="Functions">Functions</option>
          <option value="DOM">DOM</option>
          <option value="High-priority">High-Priority</option>
        </select>
      </div>
      <div className="mb-3">
        <label htmlFor="newTaskCreateTitle" className="col-form-label">
          Title:
        </label>
        <input
          type="text"
          className="form-control"
          id="newTaskCreateTitle"
          value={title}
          onChange={(event) => setTitle(event.target.value)}
        />
      </div>
      <div className="mb-3">
        <label htmlFor="newTaskCreateOrderNumber" className="col-form-label">
          Order Number:
        </label>
        <input
          type="number"
          className="form-control"
          id="newTaskCreateOrderNumber"
          value={orderNumber}
          onChange={(event) => setOrderNumber(Number(event.target.value))}
        />
      </div>
      <div className="mb-3">
        <label htmlFor="newTaskCreateComplexity" className="col-form-label">
          Complexity:
        </label>
        <input
          type="number"
          className="form-control"
          id="newTaskCreateComplexity"
          value={complexity}
          onChange={(event) => setComplexity(Number(event.target.value))}
        />
      </div>
      <div className="mb-3">
        <label htmlFor="newTaskCreateText" className="col-form-label">
          Text:
        </label>
        <textarea
          type="text"
          className="form-control"
          id="newTaskCreateText"
          value={text}
          onChange={(event) => setText(event.target.value)}
        ></textarea>
      </div>
      <div className="mb-3">
        <label htmlFor="newTaskCreateCode" className="col-form-label">
          Code:
        </label>
        <textarea
          type="text"
          className="form-control"
          id="newTaskCreateCode"
          value={code}
          onChange={(event) => setCode(event.target.value)}
        ></textarea>
      </div>
      <div className="mb-3">
        <label htmlFor="newTaskCreateCodeLanguage" className="col-form-label">
          Code Language:
        </label>
        <select
          className="form-select"
          id="newTaskCreateCodeLanguage"
          aria-label="Code Language"
          onChange={(event) => setCodeLanguage(event.target.value)}
          defaultValue="javascript"
        >
          <option value="javascript">javascript</option>
          <option value="html">html</option>
          <option value="jsx">jsx</option>
          <option value="css">css</option>
          <option value="scss">scss</option>
        </select>
      </div>
      <div className="mb-3">
        <label htmlFor="newTaskCreateOptionalText" className="col-form-label">
          Optional text:
        </label>
        <textarea
          type="text"
          className="form-control"
          id="newTaskCreateOptionalText"
          value={optionalText}
          onChange={(event) => setOptionalText(event.target.value)}
        ></textarea>
      </div>
      <Alert message={alertMessage} className={alertClass} />
      <button type="submit" className="btn btn-primary col-2">
        Create
      </button>
    </form>
  );
}
